import React, { useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./RegistrationFormPage.css";
import ugaaLogo from "../../Assets/images/logo-rmbg.png";
import {
  titles,
  genders,
  maritalStatuses,
  residenceHalls,
  associateSchools,
  academicStatuses,
  professionalStatuses,
  getYearOptions,
} from "../../../utils/options";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function RegistrationFormPage() {
  const [step, setStep] = useState(1);
const [isSubmitting, setIsSubmitting] = useState(false); // ✅ ADD THIS
  const years = getYearOptions(50); // last 50 years

  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
    mobileNumbers: ["231", "231"], // default Liberia code without "+"
    email: "",
    homeTelephone: "231", // default Liberia code without "+"
    address: "",
    maritalStatus: "",
    residenceHall: "",
    yearOfAdmission: "",
    yearOfGraduation: "",
    areaOfStudy: "",
    associateSchool: "",
    academicStatus: "",
    professionalStatus: "",
    dependents: [
      { name: "", relationship: "", dateOfBirth: "", location: "" },
      { name: "", relationship: "", dateOfBirth: "", location: "" },
      { name: "", relationship: "", dateOfBirth: "", location: "" },
      { name: "", relationship: "", dateOfBirth: "", location: "" },
    ],
    nextOfKinName: "",
    emergencyContactName: "",
    emergencyContactPhone: "231",
    agreedToPolicies: false,
  });

  

  

  const nextStep = () => setStep((prev) => Math.min(prev + 1, 4));
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 1));

  const handleChange = (e, dependentIndex) => {
    const { name, value, type, checked } = e.target;

    // Dependents
    if (name.startsWith("dependent") && dependentIndex !== undefined) {
      const updatedDependents = [...formData.dependents];
      const field = name.split("-")[1];
      updatedDependents[dependentIndex][field] = value;
      setFormData({ ...formData, dependents: updatedDependents });
      return;
    }

    // Checkbox
    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handlePhoneChange = (value, field, mobileIndex) => {
  // Normalize number: remove leading 0 after country code
  // Supports Liberia (231) & Ghana (233)
  const countryCodes = ["231", "233"];
  countryCodes.forEach((code) => {
    if (value.startsWith(code + "0")) {
      value = code + value.slice(code.length + 1);
    }
  });

  if (field === "mobile") {
    // For multiple mobile numbers
    const updatedMobiles = [...formData.mobileNumbers];
    updatedMobiles[mobileIndex] = value;
    setFormData({ ...formData, mobileNumbers: updatedMobiles });
  } else {
    // For single phone fields (homeTelephone, emergencyContactPhone)
    setFormData({ ...formData, [field]: value });
  }
};


 const handleSubmit = async (e) => {
  e.preventDefault();

  if (step < 4) {
    nextStep();
    return;
  }

  setIsSubmitting(true); // ✅ START LOADING

  console.log("Posting to:", `${API_BASE_URL}/alumni`);
  console.log("Form Data:", formData);

  try {
    const response = await axios.post(`${API_BASE_URL}/alumni`, formData);
    alert("Your registration was successful and is pending approval.");
    window.history.back();
    console.log(response.data);
  } catch (err) {
    console.error(err);
    alert("Failed to submit registration. Please check your data.");
  } finally {
    setIsSubmitting(false); // ✅ STOP LOADING
  }
};

  return (
    <div className="reg-page">
      <section className="reg-hero">
        <img src={ugaaLogo} alt="UGAA Liberia Logo" className="reg-hero-logo" />
        <h1>Membership Registration</h1>
        <p className="reg-hero-subtext">
          Fill out the form below to become a member of UGAA Liberia.
        </p>
      </section>

      <section className="reg-form-section">
        <form className="reg-form" onSubmit={handleSubmit}>
          <AnimatePresence exitBeforeEnter>
            {/* Step 1 */}
            {step === 1 && (
              <motion.div
                key="step1"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                className="reg-form-step"
              >
                <h2>Personal Information</h2>

                <div className="reg-input-group">
                  <label>Title</label>
                  <select name="title" value={formData.title} onChange={handleChange} required>
                    <option value="">Select Title</option>
                    {titles.map((t, i) => <option key={i} value={t}>{t}</option>)}
                  </select>
                </div>

                <div className="reg-input-group">
                  <label>Last Name</label>
                  <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
                </div>

                <div className="reg-input-group">
                  <label>First Name</label>
                  <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
                </div>

                <div className="reg-input-group">
                  <label>Middle Name</label>
                  <input type="text" name="middleName" value={formData.middleName} onChange={handleChange} />
                </div>

                <div className="reg-input-group">
                  <label>Gender</label>
                  <select name="gender" value={formData.gender} onChange={handleChange} required>
                    <option value="">Select Gender</option>
                    {genders.map((g, i) => <option key={i} value={g}>{g}</option>)}
                  </select>
                </div>

                <div className="reg-input-group">
                  <label>Date of Birth</label>
                  <input type="date" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleChange} required />
                </div>

                <div className="reg-input-group">
                  <label>Mobile Numbers</label>
                  {formData.mobileNumbers.map((mob, idx) => (
                    <PhoneInput
                      key={idx}
                      country={"lr"}
                      value={mob}
                      onChange={(value) => handlePhoneChange(value, "mobile", idx)}
                      inputProps={{ name: `mobile-${idx}`, required: idx === 0 }}
                      inputStyle={{ width: "100%" }}
                    />
                  ))}
                </div>

                <div className="reg-input-group">
                  <label>Email Address</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                </div>

                <div className="reg-input-group">
                  <label>Home Telephone</label>
                  <PhoneInput
                    country={"lr"}
                    value={formData.homeTelephone}
                    onChange={(value) => handlePhoneChange(value, "homeTelephone")}
                    inputProps={{ name: "homeTelephone" }}
                    inputStyle={{ width: "100%" }}
                  />
                </div>

                <div className="reg-input-group">
                  <label>Current Physical Address</label>
                  <input type="text" name="address" value={formData.address} onChange={handleChange} required />
                </div>

                <div className="reg-input-group">
                  <label>Marital Status</label>
                  <select name="maritalStatus" value={formData.maritalStatus} onChange={handleChange} required>
                    <option value="">Select</option>
                    {maritalStatuses.map((m, i) => <option key={i} value={m}>{m}</option>)}
                  </select>
                </div>
              </motion.div>
            )}

            {/* Step 2 */}
              
            {step === 2 && (
              <motion.div
                key="step2"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                className="reg-form-step"
              >
                <h2>University Information</h2>

                <div className="reg-input-group">
                  <label>Residence Hall at UG-Legon</label>
                  <select name="residenceHall" value={formData.residenceHall} onChange={handleChange} required>
                    <option value="">Select Hall</option>
                    {residenceHalls.map((h, i) => <option key={i} value={h}>{h}</option>)}
                  </select>
                </div>

                <div className="reg-input-group">
                  <label>Year of Admission</label>
                  <select name="yearOfAdmission" value={formData.yearOfAdmission} onChange={handleChange} required>
                    <option value="">Select Year</option>
                    {years.map((y, i) => <option key={i} value={y}>{y}</option>)}
                  </select>
                </div>

                <div className="reg-input-group">
                  <label>Year of Graduation</label>
                  <select name="yearOfGraduation" value={formData.yearOfGraduation} onChange={handleChange} required>
                    <option value="">Select Year</option>
                    {years.map((y, i) => <option key={i} value={y}>{y}</option>)}
                  </select>
                </div>

                <div className="reg-input-group">
                  <label>Area of Study at UG</label>
                  <input type="text" name="areaOfStudy" value={formData.areaOfStudy} onChange={handleChange} required />
                </div>

                <div className="reg-input-group">
                  <label>For Associate Members - School Graduated From</label>
                  <select name="associateSchool" value={formData.associateSchool} onChange={handleChange}>
                    <option value="">Select School</option>
                    {associateSchools.map((s, i) => <option key={i} value={s}>{s}</option>)}
                  </select>
                </div>

                <div className="reg-input-group">
                  <label>Current Academic Status</label>
                  <select name="academicStatus" value={formData.academicStatus} onChange={handleChange}>
                    <option value="">Select Status</option>
                    {academicStatuses.map((s, i) => <option key={i} value={s}>{s}</option>)}
                  </select>
                </div>

                <div className="reg-input-group">
                  <label>Current Professional Status</label>
                  <select name="professionalStatus" value={formData.professionalStatus} onChange={handleChange}>
                    <option value="">Select Status</option>
                    {professionalStatuses.map((s, i) => <option key={i} value={s}>{s}</option>)}
                  </select>
                </div>
              </motion.div>
            )}
             
             {/* Step 3: Dependents & Emergency */}
            {step === 3 && (
              <motion.div
                key="step3"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                className="reg-form-step"
              >
                <h2>Dependents & Emergency Contact</h2>

                {formData.dependents.map((dep, i) => (
                  <div key={i} className="reg-input-group reg-dependents">
                    <label>Dependent {i + 1}</label>
                    <input
                      type="text"
                      name={`dependent-name`}
                      value={dep.name}
                      onChange={(e) => handleChange(e, i)}
                      placeholder="Name"
                    />
                    <input
                      type="text"
                      name={`dependent-relationship`}
                      value={dep.relationship}
                      onChange={(e) => handleChange(e, i)}
                      placeholder="Relationship"
                    />
                    <input
                      type="date"
                      name={`dependent-dateOfBirth`}
                      value={dep.dateOfBirth}
                      onChange={(e) => handleChange(e, i)}
                      placeholder="Date of Birth"
                    />
                    <input
                      type="text"
                      name={`dependent-location`}
                      value={dep.location}
                      onChange={(e) => handleChange(e, i)}
                      placeholder="Location"
                    />
                  </div>
                ))}

                <div className="reg-input-group">
                  <label>Next of Kin Name</label>
                  <input
                    type="text"
                    name="nextOfKinName"
                    value={formData.nextOfKinName}
                    onChange={handleChange}
                    placeholder="Next of Kin"
                    required
                  />
                </div>

                <div className="reg-input-group">
                  <label>Emergency Contact Name & Number</label>
                  <input
                    type="text"
                    name="emergencyContactName"
                    value={formData.emergencyContactName}
                    onChange={handleChange}
                    placeholder="Name"
                    required
                  />
                  <PhoneInput
                    country={"lr"}
                    value={formData.emergencyContactPhone}
                    onChange={(value) =>
                      handlePhoneChange(value, "emergencyContactPhone")
                    }
                    inputProps={{
                      name: "emergencyContactPhone",
                      required: true,
                    }}
                    inputStyle={{ width: "100%" }}
                  />

                </div>
              </motion.div>
            )}

            {/* Step 4: Policies */}
            {step === 4 && (
              <motion.div
                key="step4"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                className="reg-form-step"
              >
                <h2>Policies & Agreement</h2>
                <div className="reg-input-group">
                  <textarea
                    rows="10"
                    readOnly
                    value={`I have read, understood, and accepted the terms and conditions of being a member of UGAA Liberia, and as such, do hereby promise to abide by the Constitution and Bye Laws of the Association.`}
                  />
                </div>
                <div className="reg-input-group reg-checkbox-group">
                  <input
                    type="checkbox"
                    name="agreedToPolicies"
                    checked={formData.agreedToPolicies}
                    onChange={handleChange}
                    required
                  />
                  <label>I have read and agree to the Policies & Terms</label>
                </div>
              </motion.div>
            )}



          </AnimatePresence>

          {/* Navigation */}
          <div className="reg-form-navigation">
            {step > 1 && <button type="button" className="reg-secondary-btn" onClick={prevStep}>Previous</button>}
            {step < 4 && <button type="button" className="reg-primary-btn" onClick={nextStep}>Next</button>}
              
              {step === 4 && (
                <button 
                  type="submit" 
                  className="reg-primary-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving, please wait..." : "Submit Registration"}
                </button>
              )}

          </div>
        </form>
      </section>
    </div>
  );
}
